var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.33333 0C8.00835 0 8.55556 0.541971 8.55556 1.21053V2.42105H13.4444V1.21053C13.4444 0.541971 13.9917 0 14.6667 0C15.3417 0 15.8889 0.541971 15.8889 1.21053V2.42105H19.5556C20.9056 2.42105 22 3.50499 22 4.84211V20.5789C22 21.9161 20.9056 23 19.5556 23H2.44444C1.09442 23 0 21.9161 0 20.5789V4.84211C0 3.50499 1.09442 2.42105 2.44444 2.42105H6.11111V1.21053C6.11111 0.541971 6.65832 0 7.33333 0ZM6.11111 4.84211H2.44444V8.47368H19.5556V4.84211H15.8889V6.05263C15.8889 6.72119 15.3417 7.26316 14.6667 7.26316C13.9917 7.26316 13.4444 6.72119 13.4444 6.05263V4.84211H8.55556V6.05263C8.55556 6.72119 8.00835 7.26316 7.33333 7.26316C6.65832 7.26316 6.11111 6.72119 6.11111 6.05263V4.84211ZM19.5556 10.8947H2.44444V20.5789H19.5556V10.8947Z",
    fill: "#0D0D0D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCalendar);
export default __webpack_public_path__ + "static/media/ic-calendar.4fcdaf537d0f87476132efa5eb0c4ebc.svg";
export { ForwardRef as ReactComponent };